module.exports = __webpack_public_path__ + "img/FR18989.35baa461.png";